/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

import { l } from "@atproto/lex";

const $nsid = "place.stream.beta.getStatus";

export { $nsid };

export const $params = /*#__PURE__*/ l.params({"feature":/*#__PURE__*/ l.string(),"did":/*#__PURE__*/ l.optional(/*#__PURE__*/ l.string({"format":"did"}))});

export type $Params = l.InferOutput<typeof $params>;

export const $output = /*#__PURE__*/ l.jsonPayload({"feature":/*#__PURE__*/ l.string(),"did":/*#__PURE__*/ l.string({"format":"did"}),"status":/*#__PURE__*/ l.string<{"knownValues":["granted","requested","none"]}>()});

export type $Output<B = l.BinaryData> = l.InferPayload<typeof $output, B>;
export type $OutputBody<B = l.BinaryData> = l.InferPayloadBody<typeof $output, B>;

/** Report an account's access status for a named beta feature: whether it has been granted (via a trusted place.stream.beta.invite, or because this node isn't beta-gating the feature), has an outstanding place.stream.beta.request, or neither. Defaults to the authenticated caller when `did` is omitted. */
const main = /*#__PURE__*/ l.query($nsid, $params, $output, ["DidRequired"]);

export { main };

export const $lxm = $nsid;
